import { render, staticRenderFns } from "./MessengerIcon.vue?vue&type=template&id=12180e1d&scoped=true"
import script from "./MessengerIcon.vue?vue&type=script&lang=js"
export * from "./MessengerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12180e1d",
  null
  
)

export default component.exports